function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 28.87,
  height: 28.87,
  fill: "transparent"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m7.09 21.82.23-.87c.24-.89.49-1.77.72-2.66a.65.65 0 0 0 0-.43 7.32 7.32 0 1 1 3.16 3.08.73.73 0 0 0-.45 0c-1.98.44-3.26.8-3.66.88zm1.71-1.68c.73-.19 1.4-.36 2.07-.54a.6.6 0 0 1 .5.07 6 6 0 0 0 4.05.77 6.12 6.12 0 1 0-6.31-3.09 1.28 1.28 0 0 1 .14 1.16c-.18.49-.25 1.04-.45 1.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.37 17.89c-1.43-.05-3.71-1.18-5.27-3.89a2.2 2.2 0 0 1 .34-2.81 1 1 0 0 1 .94-.14c.08 0 .16.13.2.22.21.47.41.95.59 1.43.1.26-.08.5-.45.92a.32.32 0 0 0 0 .42 5 5 0 0 0 2.54 2.18.3.3 0 0 0 .39-.1c.58-.71.64-.92 1-.78 1.48.71 1.59.74 1.6.9a1.61 1.61 0 0 1-1.88 1.65z"
})));

const SvgWhatsapp = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28.87 28.87",
  id: "whatsapp",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Whatsapp.a3f330e1.svg";
export { ForwardRef as ReactComponent };